import { render } from "./EditPostModal.vue?vue&type=template&id=27d6653c&scoped=true"
import script from "./EditPostModal.vue?vue&type=script&lang=js"
export * from "./EditPostModal.vue?vue&type=script&lang=js"

import "./EditPostModal.vue?vue&type=style&index=0&id=27d6653c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d6653c"]])

export default __exports__